import styled from "@emotion/styled";
import { Property } from "csstype";

import { sizeToken } from "../../../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface CellProps {
    width?: number;
    textAlign?: Property.TextAlign | undefined;
    flexBasis?: string | number;
}

export const Cells = styled.div({
    display: "inline-flex",
});

export const Cell = styled.div<CellProps>(props => ({
    display: "inline-block",
    flexBasis: props.flexBasis,
    verticalAlign: "top",
    width: props.width,
    textAlign: props.textAlign,
    marginRight: sizeToken(2),

    ":last-of-type": {
        marginRight: 0,
    },

    p: {
        margin: 0,
    },

    ul: {
        margin: 0,
        paddingInlineStart: 20,

        li: {
            margin: 0,
        },
    },

    ol: {
        margin: 0,
        paddingInlineStart: 20,

        li: {
            margin: 0,
        },
    },
}));

export const Root = styled.div(props => ({
    margin: `0 24px 12px 24px`,
    padding: `0 8px`,
    borderRadius: "8px",
    cursor: "pointer",
    userSelect: "none",

    "&:hover": {
        backgroundColor: theme(props).keyPalette.panelBackgroundColor,
        boxShadow: `${theme(props).keyPalette.panelBackgroundColor} 0px 0px 0px 4px`,
    },
}));
